// src/components/projects/ProjectForm.js
import React, { useState, useEffect } from "react";
import { createProject, getProjects } from "../../api/project/projectApi";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import "./ProjectForm.css";
import { FaInfoCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { FaSquarePlus } from "react-icons/fa6";

const ProjectForm = ({ onClose }) => {
  const [projectName, setProjectName] = useState("");
  const [existingprojects, setExistingProjects] = useState([]);
  const [privacy, setPrivacy] = useState("Private"); // Default privacy setting
  const navigate = useNavigate();
  const [nameTooltip, setNameTooltip] = useState(false);

  useEffect(() => {
    const fetchProjects = async () => {
      const user_id = localStorage.getItem("user_id");
      const response = await getProjects(user_id);
      setExistingProjects(response.data.projects);
    };
    fetchProjects();
  }, []);

  const handleCreateProject = async () => {
   
    const user_id = localStorage.getItem("user_id");

    
    if (!user_id) {
      alert("User ID not found. Please log in again.");
      return;
    }

    const existingProject = existingprojects.find(
      (project) =>
        project.project_name.toLowerCase() === projectName.toLowerCase()
    );

    if (existingProject) {
      alert("Assessment already exists. Please try a new name.");
      return;
    }
    if (projectName.length < 1) {
      alert("Please enter an Assessment name.");
      return;
    }

    try {
      // Send API request with project name and user_id
      await createProject(projectName, user_id, privacy);
      alert("Assessment created successfully!");
      onClose();
      navigate("/projects"); 
    } catch (error) {
      alert("Failed to create assessment");
      console.error("Error creating assessment:", error);
    }
  };

  const toggleNameTooltip = () => {
    setNameTooltip(!nameTooltip);
  };

  return (
  <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 p-5 md:p-6 w-full max-w-2xl mx-auto">

  {/* HEADER */}
  <div className="flex justify-between items-center mb-4">
    <label className="font-semibold text-[#36369f] text-sm md:text-base flex items-center gap-2">
      Assessment Name
      <FaInfoCircle
        className="text-[#36369f] cursor-pointer hover:scale-110 transition"
        onClick={toggleNameTooltip}
      />
      
    </label>

    <button
      onClick={onClose}
      className="text-red-500 hover:bg-red-100 p-2 rounded-full transition"
    >
      <MdCancel className="text-lg md:text-xl" />
    </button>
  </div>

  {/* TOOLTIP */}
  {nameTooltip && (
    <div className="bg-[#36369f]/10 border border-[#36369f]/20 p-3 rounded-xl text-xs md:text-sm text-gray-600 mb-4">
      Choose an Assessment Name that is relevant to the topic.
    </div>
  )}

  {/* MAIN CONTENT */}
  <div className="flex md:flex-row flex-col gap-4">

    {/* PRIVACY */}
    <div className="w-full md:w-[200px] bg-gray-50 p-2 rounded-2xl flex md:flex-col flex-row gap-2">

      <button
        onClick={() => setPrivacy("Private")}
        className={`flex-1 py-2 rounded-xl text-sm font-semibold transition ${
          privacy === "Private"
            ? "bg-white text-[#36369f] shadow border border-[#36369f]/20"
            : "text-gray-600 hover:bg-white"
        }`}
      >
        Private
      </button>

      <button
        onClick={() => setPrivacy("Public")}
        className={`flex-1 py-2 rounded-xl text-sm font-semibold transition ${
          privacy === "Public"
            ? "bg-white text-[#36369f] shadow border border-[#36369f]/20"
            : "text-gray-600 hover:bg-white"
        }`}
      >
        Public
      </button>

    </div>

    {/* INPUT + BUTTONS */}
    <div className="w-full">

      <input
        className="w-full py-2.5 px-4 rounded-xl text-sm md:text-base border-2 border-[#36369f] focus:ring-2 focus:ring-[#36369f] outline-none transition"
        type="text"
        placeholder="Enter Assessment Name"
        value={projectName}
        onChange={(e) => setProjectName(e.target.value)}
      />

      <div className="flex gap-3 pt-4">

        <button
          className="w-full flex justify-center items-center gap-2 bg-[#36369f] hover:bg-[#2e2e85] rounded-xl py-2.5 text-white font-semibold shadow-md transition hover:scale-[1.02]"
          onClick={handleCreateProject}
        >
          Create
          <FaSquarePlus />
        </button>

        <button
          className="w-full hidden md:flex justify-center items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl py-2.5 font-semibold"
          onClick={onClose}
        >
          Cancel
          <MdCancel />
        </button>

      </div>

    </div>

  </div>
</div>
  );
};

export default ProjectForm;